export default __webpack_public_path__ + "static/media/cif-cz.929eb432.svg";